import { Base_Url } from "../../../BaseURL/BaseUrl";
import { getApiWithAuthorization, postApiWithAuthorization } from "../../ApiMethods/ApiMethod";

const ServiceUrl = `${Base_Url}/Service`;

export const GetServiceList = async (params) => {
    const res = await postApiWithAuthorization(`${ServiceUrl}/GetServiceList`, params);
    return res;
};

export const AddUpdateService = async (params) => {
    const res = await postApiWithAuthorization(`${ServiceUrl}/AddUpdateService?ModuleName=${params.ModuleName}`, params);
    return res;
};
export const GetServiceModel = async (ModuleName, KeyID, UserKeyID) => {
    const res = await getApiWithAuthorization(`${ServiceUrl}/GetServiceModel?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}&ServiceKeyID=${KeyID}`);
    return res;
};

export const ChangeServiceStatus = async (ModuleName, KeyID, UserKeyID) => {
    const res = await getApiWithAuthorization(`${ServiceUrl}/ChangeServiceStatus?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}&ServiceKeyID=${KeyID}`);
    return res;
};

export const DeleteService = async (ModuleName, KeyID, UserKeyID) => {
    const res = await getApiWithAuthorization(`${ServiceUrl}/DeleteService?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}&ServiceKeyID=${KeyID}`);
    return res;
};

export const GetServiceLookupList = async (ModuleName, KeyID) => {
    const res = await getApiWithAuthorization(`${ServiceUrl}/GetServiceLookupList?ModuleName=${ModuleName}&UserKeyID=${KeyID}`);
    return res;
};